export default {
  PAGING: '&page=1&size=10',
  APPS: {
    ADD_APP: 'add',
    COPY_APP: 'copy/',
    FETCH_APPS: 'list',
    FETCH_ALL_APPS: 'list/admin',
    FETCH_OWNER_APPS: 'getByOwner',
    UPDATE_APP: 'update/',
    DETAIL_APP: 'detail/',
    DUP_APP: 'newVersion/',
    FULL_SECTION_DETAIL: '/APPLICATION_ACTIONS',
    UPDATE_APP_BEACON: 'update/APPLICATION_BEACON',
    FETCH_APP_BEACON: 'APPLICATION_BEACON',
    FETCH_APP_DEPLOY: 'APPLICATION_DEPLOY',
    UPDATE_APP_DEPLOY: 'update/',
    ASK_DEPLOY: 'deploy/',
    FETCH_CGU: 'cgu/',
    UPDATE_CGU: 'cgu',
    FETCH_PRIVACY_POLICY: 'privacyPolicy/',
    UPDATE_PRIVACY_POLICY: 'privacyPolicy',
    UPDATE_STYLES: 'update/list/',
    ADD_TEAM_APP: '/addMemberAndApp/',
    GENERATE_KEYSTORE: 'keystore/',
  },
  MEDIAS: {
    FETCH_MEDIAS: 'list/',
    ADD_MEDIA: 'add/',
  },
  CONTENTS: {
    FETCH_CONTENTS: 'list/',
    DETAIL_CONTENT: 'detail/',
    SECTION_CONTENT: '/SECTION_CONTENT',
    SECTION_CONTENT_GENERICS: '/SECTION_CONTENT_GENERICS',
    SECTION_CONTENT_ANNUAIRE: '/SECTION_CONTENT_ANNUAIRE',
    SECTION_CONTENT_GEOLOC: '/SECTION_CONTENT_GEOLOC',
    SECTION_CONTENT_MAP: '/SECTION_CONTENT_MAP',
    SECTION_CONTENT_PLAN: '/SECTION_CONTENT_PLAN',
    SECTION_CONTENT_RA: '/SECTION_CONTENT_RA',
    SECTION_CONTENT_DASHBOARD: '/SECTION_CONTENT_DASHBOARD',
    SECTION_CONTENT_ON_BOARDING: '/SECTION_CONTENT_ON_BOARDING',
    SECTION_CONTENT_CATALOG: '/SECTION_CONTENT_CATALOG',
    SECTION_CONTENT_MAPWIZE: '/SECTION_CONTENT_MAPWIZE',
    SECTION_CONTENT_CHAT: '/SECTION_CONTENT_CHAT',
    SECTION_CONTENT_PLANNER: '/SECTION_CONTENT_PLANNER',
    SECTION_CONTENT_PLUGIN: '/SECTION_CONTENT_PLUGIN',
    SECTION_CONTENT_RESOURCE_MANAGER: '/SECTION_CONTENT_RESOURCE_MANAGER',
    SECTION_CONTENT_FORM: '/SECTION_CONTENT_FORM',
    SECTION_CONTENT_DM: '/SECTION_CONTENT_DM',
    SECTION_CONTENT_PHOTO_WALL: '/SECTION_CONTENT_PHOTO_WALL',
    SECTION_CONTENT_BUSINESS_CARD: '/SECTION_CONTENT_BUSINESS_CARD',
    SECTION_CONTENT_SELFIE: '/SECTION_CONTENT_SELFIE',
    SECTION_CONTENT_GENERICS_LIST: '/SECTION_CONTENT_GENERICS_LIST',
    SECTION_CONTENT_NEWS: '/SECTION_CONTENT_NEWS',
    APPLICATION_DASHBOARD: '/APPLICATION_DASHBOARD',
    APPLICATION_DASHBOARD_NO_ID: 'APPLICATION_DASHBOARD',
    FETCH_TYPES: {
      GENERICS: 'genericTypes',
      PERSONALS: 'personalTypes',
      PAGE: 'page',
    },
    CREATE_GENERIC: 'addGeneric/',
    CREATE_PERSONAL: 'addPersonal/',
    CREATE_PAGE: 'add/page/',
    CREATE_CONTENT: 'add/',
    UPDATE_CONTENT: 'update/SECTION_CONTENT',
    UPDATE_CONTENT_GENERICS: 'update/SECTION_CONTENT_GENERICS',
    UPDATE_CONTENT_ANNUAIRE: 'update/SECTION_CONTENT_ANNUAIRE',
    UPDATE_CONTENT_GEOLOC: 'update/SECTION_CONTENT_GEOLOC',
    UPDATE_CONTENT_CATALOG: 'update/SECTION_CONTENT_CATALOG',
    UPDATE_CONTENT_MAP: 'update/SECTION_CONTENT_MAP',
    UPDATE_CONTENT_PLAN: 'update/SECTION_CONTENT_PLAN',
    UPDATE_CONTENT_RA: 'update/SECTION_CONTENT_RA',
    UPDATE_CONTENT_DASHBOARD: 'update/SECTION_CONTENT_DASHBOARD',
    UPDATE_CONTENT_ON_BOARDING: 'update/SECTION_CONTENT_ON_BOARDING',
    UPDATE_CONTENT_MAPWIZE: 'update/SECTION_CONTENT_MAPWIZE',
    UPDATE_CONTENT_CHAT: 'update/SECTION_CONTENT_CHAT',
    UPDATE_CONTENT_PLANNER: 'update/SECTION_CONTENT_PLANNER',
    UPDATE_CONTENT_PLUGIN: 'update/SECTION_CONTENT_PLUGIN',
    UPDATE_CONTENT_RESOURCE_MANAGER: 'update/SECTION_CONTENT_RESOURCE_MANAGER',
    UPDATE_CONTENT_FORM: 'update/SECTION_CONTENT_FORM',
    UPDATE_CONTENT_DM: 'update/SECTION_CONTENT_DM',
    UPDATE_CONTENT_PHOTO_WALL: 'update/SECTION_CONTENT_PHOTO_WALL',
    UPDATE_CONTENT_BUSINESS_CARD: 'update/SECTION_CONTENT_BUSINESS_CARD',
    UPDATE_CONTENT_GENERICS_LIST: 'update/SECTION_CONTENT_GENERICS_LIST',
    UPDATE_CONTENT_SELFIE: 'update/SECTION_CONTENT_SELFIE',
    UPDATE_CONTENT_NEWS: 'update/SECTION_CONTENT_NEWS',
    UPDATE_CONTENTS_POS: 'update/SECTION_CONTENTS_POS',
    UPDATE_PLUGIN_MANIFEST: 'update/SECTION_PLUGIN_MANIFEST',
    UPDATE_MENU_POSITION: 'update/list/SECTION_POSITION',
    UPDATE_PRESENTATION: 'update/SECTION_PRESENTATION',
    NOTIFY_CONTENT: 'update/CONTENT_NOTIFY',
    DUP_CONTENT: 'duplicate/',
  },
  USER_MANAGEMENT: {
    FETCH_USERS: 'list/',
    FETCH_USERS_IN_GROUPS: 'inGroups/',
    DETAIL_USER: 'detail/',
    ADD_USER: 'add/',
    MODIFY_USER: '/',
    DELETE_USER: '/',
    FETCH_GROUP: 'list/',
    DETAIL_GROUP: 'detail/',
    ADD_GROUP: 'add/',
    MODIFY_GROUP: '/',
    DELETE_GROUP: '/',
    IMPORT_LDAP_USERS: 'importLdapUsers/',
    IMPORT_LDAP_GROUPS: 'importLdapGroups/',
    TEST_LDAP_CONFIG: 'testLdapConfig',
    FETCH_AZURE_GROUPS: 'getAzureADGroups/',
  },
  API_KEY: {
    FETCH_API_KEYS: 'list/',
    ADD_API_KEY: 'add/',
    DELETE_API_KEY: '',
    AUTHORIZATIONS: 'authorizations',
  },
  TEAM: {
    FETCH_TEAM: 'list',
    ADD_MEMBER: 'addMember',
    REMOVE_MEMBER: 'deleteMember',
    UPDATE_PROFILE: 'update/profile',
  },
  NOTIF: {
    PREVIEW_NOTIF: 'previewNotif/',
    SEND_NOTIF: 'sendNotif/',
    SEND_TECH_NOTIF: 'sendTechNotif/',
    FETCH_TO_SEND_NOTIF: 'toSend/',
    FETCH_SENT: 'sent/',
  },
  LOCALE: {
    FETCH_LOCALES: 'list/',
  },
  AUTH: 'userfo/auth',
  LOGOUT: 'userfo/logout',
  DELETE_ACCOUNT: 'userfo/requestAccountDeletion',
  // REINIT_PASSWORD: 'changePasswordRequest?json=true',
  REINIT_PASSWORD: 'resetPassword',
  USER_MODIFICATION: 'userfo/updateProfile/',
  USER_MODIFICATION_PASSWORD: 'userfo/updatePassword',
  STYLES: {
    FETCH_STYLES: 'list/',
    FETCH_COLORS: 'colors/',
    FETCH_FONTS: 'fontFamily/list/',
    ADD_FONTS: 'fontFamily/',
    COLORS_MAPPING: 'colorMapping/'
  },
  PLAN: {
    GET: 'list/',
    GET_DETAIL: 'detail/',
    SET: 'add/',
    DELETE: '',
    UPDATE: '',
  },
  MAP: {
    SET: 'add/',
    DELETE: '',
    UPDATE: '',
    FETCH_POIS: 'list/',
    FETCH_POIS_CATEGORY: 'list/category/',
    FETCH_TYPES: 'list/',
    VENUES: 'venue/',
    FETCH_VENUES: 'list/',
    POI: 'poi/',
    FETCH_POI: 'list/',
    SAVE_LINK: 'link/',
  },
  IOT: {
    FETCH_BEACONS: 'list/',
    CREATE_BEACON: 'add/',
    UPDATE_BEACON: 'update/BEACON_DETAIL',
    DELETE_BEACON: '',
    FETCH_BEACON_ACTIONS: 'action/list/',
    UPDATE_BEACON_ACTIONS: 'action/update/BEACON_ACTION',
    DELETE_ACTION: 'action/',
  },
  RA: {
    FETCH_TAGS: 'image/list',
    DELETE_TAG: '',
  },
  ADDRESS_BOOKS: {
    GET: 'list/',
    ADD: 'add/',
    UPDATE: '',
    DELETE: '',
  },
  USERS_AND_PROFILES: {
    LIST: 'list/',
    FREEMIUM_LIST: 'freemium/list',
    DETAIL: 'detail/',
    AUTH_LIST: 'authList/',
  },
  DATASOURCES: {
    KEYVALUETYPE_LIST: 'type/list/',
    KEYVALUETYPE_ADD: 'type/add/',
    KEYVALUETYPE_UPDATE: 'type/',
    KEYVALUETYPE_DELETE: 'type/',
    KEYVALUE_LIST: 'list/',
    KEYVALUE_ADD: 'add/',
    KEYVALUE_UPDATE: '',
    KEYVALUE_DELETE: '',
    FOLDERTYPE_LIST: 'type/list/',
    FOLDERTYPE_ADD: 'type/add/',
    FOLDERTYPE_UPDATE: 'type/',
    FOLDERTYPE_DELETE: 'type/',
    FILE_LIST: 'list/',
    FILE_ADD: 'add/',
    FILE_UPDATE: '',
    FILE_DELETE: '',
    PLANNERS_LIST: 'list/',
    PLANNERS_ADD: 'add/',
    PLANNERS_UPDATE: '',
    PLANNERS_DELETE: '',
    CHECKINS_LIST: 'list/',
    CHECKINS_ADD: 'add/',
    CHECKINS_UPDATE: '',
    CHECKINS_DELETE: '',
    CHATS_LIST: 'list/',
    CHATS_ADD: 'add/',
    CHATS_UPDATE: '',
    CHATS_DELETE: '',
    RESOURCE_MANAGERS_LIST: 'list/',
    RESOURCE_MANAGERS_ADD: 'add/',
    RESOURCE_MANAGERS_UPDATE: '',
    RESOURCE_MANAGERS_DELETE: '',
    FORMS_LIST: 'list/',
    FORMS_ADD: 'add/',
    FORMS_UPDATE: '',
    FORMS_DELETE: '',
    DMS_LIST: 'list/',
    DMS_ADD: 'add/',
    DMS_UPDATE: '',
    DMS_DELETE: '',
    GENERICS_LIST: 'list/',
    GENERICS_ADD: 'add/',
    GENERICS_UPDATE: '',
    GENERICS_DELETE: '',
  },
}
